import { REGION_HOST } from '@/constants';
import type { RegionRepository } from '@/Domain/repositories/RegionRepository';
import type { HttpRegionDto } from '@/modules/region/infrastructure/dto/HttpRegionDto';
import { httpRegionDtoToRegionResponse } from '@/modules/region/infrastructure/mappers/httpRegionDtoToRegionResponse';
import regions from '@/modules/region/mocks/region-comune-response.json';

const ERROR_MESSAGE = 'Error fetching regions';

const getAll: RegionRepository['getAll'] = async () => {
  try {
    const response = await fetch(REGION_HOST);
    const data: HttpRegionDto = await response.json();

    if (!response.ok || data.status != 200) {
      console.error(ERROR_MESSAGE, data.status);
      return httpRegionDtoToRegionResponse(regions);
    }

    return httpRegionDtoToRegionResponse(data);
  } catch (error) {
    console.error(ERROR_MESSAGE, error);
    return httpRegionDtoToRegionResponse(regions);
  }
};

export const createHttpRegionesListRepository = (): RegionRepository => ({
  getAll
});
